module.exports = __webpack_public_path__ + "img/logo.b951d9e3.jpg";